import { memo } from "react";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { BillLineItem } from "@common/types/bill";
import { toDisplayDateOnly } from "@helpers/date";
import { PeriodLockIcon } from "@components/periodLock/PeriodLockIcon";
import { useIsEntityDateLocked } from "@components/periodLock/PeriodLockDatesProvider";

interface Props {
    row: Row<ViewTableFeatures, BillLineItem>;
}

export const LockCell = memo(({ row }: Props) => {
    const bill = row.original.bill;
    const isLocked = useIsEntityDateLocked(
        bill?.entityId ?? null,
        toDisplayDateOnly(bill?.dateOnly),
    );

    if (!isLocked) {
        return null;
    }

    return (
        <PeriodLockIcon
            label="This bill is locked."
            testId="bill-line-item-lock"
        />
    );
});
LockCell.displayName = "LockCell";
